import React from 'react'
import { t } from 'ttag'
import PropTypes from 'prop-types'

const OccupationInfo = ({ item }) => {
  //console.log(item)

  const wages = () => {
    const avgWage = item.relevantInfo?.annualWage

    if (avgWage) {
      const formattedWage = avgWage.toLocaleString('en-US', {
        style: 'currency',
        minimumFractionDigits: 0,
        currency: 'USD'
      })

      return (
        <div className="personalization-item">
          <i className="fal fa-money-bill-wave"></i> {formattedWage}
        </div>
      )
    }

    return null
  }
  const growth = () => {
    const annualGrowthRate = item.relevantInfo?.annualGrowthRate

    if (annualGrowthRate) {
      const calc = () => {
        if (annualGrowthRate > 6) {
          return t`Growing Quickly`
        }

        if (annualGrowthRate > 0) {
          return t`Growing`
        }

        if (annualGrowthRate == 0) {
          return t`Staying the same`
        }

        if (annualGrowthRate < -6) {
          return t`Declining Quickly`
        }

        if (annualGrowthRate < 0) {
          return t`Declining`
        }
      }
      const icon = () => {
        let speed = ''

        if (annualGrowthRate > 6) {
          speed = `-fastest`
        } else if (annualGrowthRate > 0) {
          speed = `-fast`
        } else if (annualGrowthRate < -6) {
          speed = `-slowest`
        } else if (annualGrowthRate < 0) {
          speed = `-slow`
        }

        return <i className={`fal fa-tachometer${speed}`}></i>
      }

      return (
        <div className="personalization-item">
          {icon()} {calc()}
        </div>
      )
    }
  }

  return (
    <div className="personalization-holder">
      {item.relevantInfo?.education ? (
        <div className="personalization-item">
          <i className="fal fa-graduation-cap"></i> {item.relevantInfo.education}
        </div>
      ) : null}
      {wages()}
      {growth()}
      {
        //item.relevantInfo?.cluster ? <div className="personalization-item">{ item.relevantInfo.cluster}</div> : null
      }
    </div>
  )
}

OccupationInfo.propTypes = {
  item: PropTypes.object
}

export { OccupationInfo }
